import { createSlice } from '@reduxjs/toolkit'
import i18n from '../../i18n'

const initialState = {
    language: 'ua'
}

export const languageSlice = createSlice({
    name: 'language',
    initialState,
    reducers: {
        setLanguage(state, { payload }) {
            state.language = payload
            localStorage.setItem("language", payload)
            i18n.changeLanguage(payload)
        },
    },
})

export const {
    setLanguage
} = languageSlice.actions

export default languageSlice.reducer
